// Copyright (c) Docugami, Inc. All rights reserved.**/

import { dgFontFamily } from "components/common/Fonts";
import { SamplesCatalogView } from "components/myContentExplorer/SamplesCatalogView";
import { greyText, homeGray } from "components/shell/presentation/AppStyles";
import { useNavigationService } from "hooks/navigationService";
import { FirstArrivalView, FirstArrivalViewProps } from "pages/FirstArrival";
import styled from "styled-components";

const Container = styled.div`
    height: 100%;
    width: 100%;
`;

const Content = styled.div`
    height: 95%;
    width: 100%;
    border-bottom: 1px solid ${greyText};
`;

const Footer = styled.div`
    display: flex;
    height: 5%;
    justify-content: center;
    align-items: center;
    color: ${homeGray};
    font-family: ${dgFontFamily};
`;

const UserUploadLink = styled.span`
    font-weight: 700;
    cursor: pointer;
`;

export const InstallSamplesView = (props: FirstArrivalViewProps) => {
    const navService = useNavigationService();
    return <Container>
        <Content>
            <SamplesCatalogView
                onInstall={(sampleId) => {
                    props.onComplete();
                    navService.navToBrowseSamplesPage(sampleId);
                }}
            />
        </Content>
        <Footer>
            <span>To get started by uploading files instead, click <UserUploadLink onClick={() => props.changeView(FirstArrivalView.UserUpload)}>HERE</UserUploadLink>.</span>
        </Footer>
    </Container>
}
